import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import accountStore from "../store/accountStore";
import appStore from "../../../stores/appStore";
import { Spinner } from "../../../components/ui/Spinner";
import dayjs from "dayjs";
import doneIcon from '../../../assets/done_icon.svg';
import pendingIcon from '../../../assets/pending_icon.svg';
import cancelIcon from '../../../assets/canceled_icon.svg';
import storeIcon from '../../../assets/store_icon.svg';
const MyOrders = () => {

    const isMobile = useMediaQuery({ maxWidth: 768 });

     // Эффект для загрузки заказов при монтировании и изменении авторизации
      useEffect(() => {
        if (appStore.isLoginIn) {
          accountStore.getOrders();
        } else {
          // Очищаем заказы при выходе из системы
          accountStore.orders = [];
        }
      }, [localStorage.getItem("access_token")]); // Зависимость от состояния авторизации

     // Стили для мобильных устройств
  const mobileStyles = {
    container: isMobile ? "flex-col p-2 gap-2" : "flex-row p-[20px] gap-[20px]",
    sidebar: isMobile
      ? "flex-row w-full overflow-x-auto gap-4 p-2 bg-white rounded-lg"
      : "flex-col rounded-2xl h-max bg-white p-[20px] gap-[20px] min-w-[250px] shadow-[0_2px_20px_#0000001a]",
    menuItem: isMobile
      ? "text-base whitespace-nowrap"
      : "text-[18px] tracking-[-2%]",
    content: isMobile ? "w-full" : " w-[1000px] text-[#232323]",
    orderCard: isMobile
      ? "flex flex-row not-first:mt-[10px] pb-[10px]   h-full border-b border-[#e0e0e0] last:border-0 last:mb-0 last:pb-0"
      : "flex flex-row justify-around pb-[15px] mb-[15px] border-b border-solid border-[#E0E0E0] last:border-0 last:mb-0 last:pb-0",
    orderInfo: isMobile ? "flex-row items-center w-full min h-[45px]" : "flex-1",
    deliveryInfo: isMobile
      ? "w-full text-sm items-center justify-center flex-1"
      : "flex-1 justify-center items-start",
    priceInfo: isMobile
      ? "flex flex-col   items-end ml-[15px] min-w-[98px]"
      : "flex-col flex-1",
  };

    const getOrderStatus = (status: string): string => {
    switch (status) {
      case "failed":
        return "При заказе произошла ошибка";
      case "processed":
        return "В обработке";
      case "ГотовКВыдаче":
        return "Ожидает получения";
      case "Отменен":
        return "Отменен";
      case "Выполнен":
        return "Заказ получен";
      case "Новый":
        return "В обработке";
      default:
        return status;
    }

  };

  const getOrderIcon = (status: string)  => { 
      switch (status) {
        case "В обработке":
          return pendingIcon;
        case "Ожидает получения":
          return storeIcon;
        case "Отменен":
          return cancelIcon;
        case "Заказ получен":
          return doneIcon;
        case "При заказе произошла ошибка":
          return cancelIcon;
        case "Ошибка":
          return cancelIcon;
        default:
          return pendingIcon;
      }
    };

  return (
    <div className={`flex flex-col gap-[20px] ${mobileStyles.content}`}>
           <h2 className={`${isMobile ? "text-xl" : "text-[20px]"} font-semibold`}>
             Мои заказы
           </h2>
 
           <div
             className={`bg-white ${
               isMobile ? "rounded-[20px] shadow-[0_2px_20px_#0000001a] !bg-white p-[15px]" : "rounded-[20px] shadow-[0_2px_20px_#0000001a] p-[20px]"
             } w-full`}
           >
             {!appStore.isLoginIn ? (
               <div className="flex justify-center items-center h-40">
                 <p className="text-gray-500">
                   Авторизуйтесь для просмотра заказов
                 </p>
               </div>
             ) : accountStore.orders ? (
               <div>
                 {accountStore.orders.length > 0 ? (
                   accountStore.orders.map((order) => (
                     <div
                       key={order.order_number}
                       className={`${mobileStyles.orderCard}`}
                     >
                       <div className={`flex ${mobileStyles.orderInfo} `}>
                          <img src={getOrderIcon(getOrderStatus(order.status))} alt="status icon" className="w-[36px] h-[36px] mr-2 mt-auto mb-auto"/>
                         <div className="flex flex-col ">
                           <span
                             className={`${
                               isMobile ? "text-sm" : "text-[16px] tracking-[-2%] font-semibold"
                             } font-bold`}
                           >
                             № {order.order_number}
                           </span>
                           <span
                             className={`${
                               isMobile ? "text-xs" : "text-[13px] line-height-[19px] tracking-[-2%]"
                             } text-[#828282] font-medium`}
                           >
                             {getOrderStatus(order.status)}
                           </span>
                         </div>
                       </div>
                      {!isMobile && (
           <div className={`flex ${mobileStyles.deliveryInfo}`}>
                         <span
                           className={`${
                             isMobile ? "text-sm" : "text-[16px] tracking-[-2%]"
                           } font-semibold`}
                         >
                           {order.delivery_point.replace(/\s*\(.*\)$/, "")}
                         </span>
                       </div>
                      )}

 
                       <div className={`flex ${mobileStyles.priceInfo}`}>
           
                           <span className="text-right text-[16px] font-semibold">
                             ₽ {order.total_amount}
                           </span>
                         <span
                           className={`${
                             isMobile ? "text-xs" : "text-right text-[13px] line-height-[19px] tracking-[-2%] font-medium"
                           } text-[#828282]`}
                         >
                           От {dayjs(order.created_at).format("DD.MM.YYYY")}
                         </span>
                       </div>
                     </div>
                   ))
                 ) : (
                   <div className="flex justify-center items-center h-40">
                     <p className="text-gray-500">У вас нет заказов</p>
                   </div>
                 )}
               </div>
             ) : (
               <div className="flex w-full justify-center items-center h-40">
                 <Spinner />
               </div>
             )}
           </div>
         </div>
  )
}

export default observer(MyOrders);